import useCachedSpecialitiesList from '@src/adapters/hooks/specialities/useCachedSpecialitiesList';
import ControlledDropdown from '../ControlledDropdown';
import { DropdownOption } from '../DropDown';
import { useEffect, useState } from 'react';

interface Props {
  fieldName: string;
}

function ControlledSpecialityAutoComplete({ fieldName }: Props) {
  const [available, setAvailable] = useState<DropdownOption[]>([]);
  const { getList } = useCachedSpecialitiesList();

  useEffect(() => {
    getList().then((result) => {
      setAvailable(result);
    });
  }, [getList]);

  return (
    <ControlledDropdown
      fieldName={fieldName}
      label="Speciality"
      options={available}
    />
  );
}
export default ControlledSpecialityAutoComplete;
